export const queryUrlValue = (key) => {
  if (!key) return "";

  const url = decodeURIComponent(window.location.href);
  const re = new RegExp(`[?|&]${key}=([^&]+)`, "g");
  const matchResult = re.exec(url);

  if (!matchResult) return "";

  let value = matchResult[1];
  if (value.includes("#")) {
    const separator = value.includes("/#") ? "/#" : "#";
    value = value.split(separator)[0];
  }

  return value;
};
